import React, { lazy } from 'react';
import { CheckIcon, CoinsIcon, BarChartIcon, PackageIcon, InstagramIcon, BookOpenIcon } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
import { buildHotmartUrl } from '../utils/hotmartTracking';
const fmt = (n: number) => `$${n.toLocaleString('es-AR')}`;
export function PricingSection() {
  // All prices in ARS
  const basePrice = 10299;
  const premiumPrice = 16199;
  const bonusValue = 20030;
  const totalBonusValue = bonusValue * 3;
  const totalValue = basePrice + totalBonusValue;
  const premiumTotalValue = premiumPrice + totalBonusValue;
  // Price for selling milhojas
  const milhojasPrice = 140490;
  const potentialMonthly = milhojasPrice * 15;
  // Handle add to cart event
  const handleAddToCart = (price: number, productName: string, productId: string) => {
    trackPixelEvent('AddToCart', {
      value: price,
      currency: 'ARS',
      content_name: productName,
      content_ids: [productId],
      content_type: 'product'
    });
  };
  return <section id="comprar" className="py-12 mb-12 bg-amber-50 rounded-lg" data-id="element-277">
      <div className="max-w-3xl mx-auto" data-id="element-278">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-279">
          Inversión Inteligente
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-280">
          Convierte Tu Pasión en Negocio Rentable
        </p>
        <p className="text-center text-gray-700 mb-8" data-id="element-281">
          Una pequeña inversión que puede transformar tu cocina en una fuente de
          ingresos
        </p>

        {/* PREMIUM BUNDLE - NEW ADDITION */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-10 border-2 border-amber-500 relative" data-id="element-282">
          <div className="absolute top-0 right-0 w-24 h-24 overflow-hidden" data-id="element-283">
            <div className="bg-amber-500 text-white font-bold text-[9px] py-1 text-center transform rotate-45 absolute top-5 right-[-35px] w-[170px] shadow-md" data-id="element-284">
              SUPER OFERTA
            </div>
          </div>
          <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white p-5 text-center" data-id="element-285">
            <div className="text-center mb-2" data-id="element-286">
              <span className="inline-block bg-amber-600 text-white font-bold px-3 py-1 rounded-full text-sm mb-2" data-id="element-287">
                MÁXIMO VALOR
              </span>
            </div>
            <h3 className="text-2xl font-bold" data-id="element-288">
              COMBO COMPLETO: RECETA + ESTRATEGIA DE VENTAS
            </h3>
            <p className="text-lg" data-id="element-289">
              Aprende a hacer y a vender milhojas profesionales
            </p>
          </div>
          <div className="p-6" data-id="element-290">
            <div className="flex flex-col md:flex-row items-center gap-6 mb-6" data-id="element-291">
              <div className="md:w-1/2" data-id="element-292">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxBGsmrT3DBz6uBHHqrUUB/COMBO_1.png" alt="Combo Milhojas y Estrategia de Instagram" className="w-full h-auto rounded-lg shadow-md" loading="lazy" data-id="element-293" />
              </div>
              <div className="md:w-1/2" data-id="element-294">
                <h4 className="text-xl font-bold text-amber-900 mb-4" data-id="element-295">
                  Lo que obtendrás:
                </h4>
                <ul className="space-y-3 mb-4" data-id="element-296">
                  <li className="flex items-start gap-2" data-id="element-297">
                    <BookOpenIcon size={20} className="text-amber-600 mt-1 flex-shrink-0" data-id="element-298" />
                    <span className="text-gray-700" data-id="element-299">
                      <span className="font-semibold" data-id="element-300">
                        Método Milhojas Perfecta
                      </span>
                      : La receta completa paso a paso
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-301">
                    <InstagramIcon size={20} className="text-amber-600 mt-1 flex-shrink-0" data-id="element-302" />
                    <span className="text-gray-700" data-id="element-303">
                      <span className="font-semibold" data-id="element-304">
                        Estrategia Instagram
                      </span>
                      : Guía paso a paso para vender tus milhojas en redes
                      sociales (incluso sin experiencia)
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-305">
                    <PackageIcon size={20} className="text-amber-600 mt-1 flex-shrink-0" data-id="element-306" />
                    <span className="text-gray-700" data-id="element-307">
                      <span className="font-semibold" data-id="element-308">3 Recetas Bonus</span>:
                      Pavlova, Tarta Ópera y Cheesecake de Maracuyá
                    </span>
                  </li>
                </ul>
                <div className="bg-amber-50 p-4 rounded-lg mb-4" data-id="element-309">
                  <div className="flex justify-between items-center" data-id="element-310">
                    <div data-id="element-311">
                      <p className="text-gray-700" data-id="element-312">Método Milhojas:</p>
                      <p className="text-gray-700" data-id="element-313">Estrategia Instagram:</p>
                      <p className="text-gray-700" data-id="element-314">3 Recetas Bonus:</p>
                      <p className="font-bold text-amber-900" data-id="element-315">Valor Total:</p>
                    </div>
                    <div className="text-right" data-id="element-316">
                      <p className="text-gray-700" data-id="element-317">{fmt(basePrice)}</p>
                      <p className="text-gray-700" data-id="element-318">
                        {fmt(premiumPrice - basePrice)}
                      </p>
                      <p className="text-gray-700" data-id="element-319">{fmt(totalBonusValue)}</p>
                      <p className="font-bold text-amber-900" data-id="element-320">
                        {fmt(premiumTotalValue)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-center" data-id="element-321">
                  <p className="text-3xl font-bold text-amber-600 mb-2" data-id="element-322">
                    {fmt(premiumPrice)}
                  </p>
                  <p className="text-sm text-amber-800 mb-4" data-id="element-323">
                    ¡Ahorras {fmt(totalBonusValue)} comprando hoy!
                  </p>
                  <a href={buildHotmartUrl('https://pay.hotmart.com/M104730533B?off=98qrssia&checkoutMode=10')} onClick={() => handleAddToCart(premiumPrice, 'Combo Milhojas + Estrategia Instagram', 'X101906538S')} className="block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-full text-lg text-center transition-colors animate-heartbeat" data-id="element-324">
                    ¡Obtener Combo Completo!
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ORIGINAL OFFER */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-8" data-id="element-325">
          <div className="bg-amber-600 text-white p-4 text-center" data-id="element-326">
            <h3 className="text-xl font-bold" data-id="element-327">¡BONOS GRATIS HOY!</h3>
            <p data-id="element-328">3 Recetas Exclusivas de Bonificación</p>
            <p className="text-sm" data-id="element-329">
              Valor adicional de {fmt(totalBonusValue)} - ¡Incluido GRATIS solo
              por hoy!
            </p>
          </div>
          <div className="p-6 flex flex-col" data-id="element-330">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 order-2 md:order-1" data-id="element-331">
              <div className="bg-amber-50 p-4 rounded-lg" data-id="element-332">
                <div className="mb-3 relative" data-id="element-333">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/81fcS41ATVic93kjfXTaRb/p1.png" alt="Libro de Pavlova con Frutas Frescas de Stella" className="w-full h-auto rounded-md shadow-sm" loading="lazy" width="400" height="300" decoding="async" data-id="element-334" />
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-335">
                    GRATIS
                  </div>
                </div>
                <h4 className="font-bold text-amber-900 mb-2" data-id="element-336">
                  Pavlova con Frutas Frescas
                </h4>
                <p className="text-sm text-gray-700 mb-2" data-id="element-337">
                  Postre australiano ligero y elegante
                </p>
                <p className="text-amber-600 font-bold" data-id="element-338">
                  Valor: {fmt(bonusValue)}
                </p>
              </div>
              <div className="bg-amber-50 p-4 rounded-lg" data-id="element-339">
                <div className="mb-3 relative" data-id="element-340">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6CAixRwdPwATq7TKJnbLWZ/t1.png" alt="Libro de Tarta Ópera de Stella" className="w-full h-auto rounded-md shadow-sm" loading="lazy" width="400" height="300" decoding="async" data-id="element-341" />
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-342">
                    GRATIS
                  </div>
                </div>
                <h4 className="font-bold text-amber-900 mb-2" data-id="element-343">
                  Tarta Ópera (Opera Cake)
                </h4>
                <p className="text-sm text-gray-700 mb-2" data-id="element-344">
                  Clásico francés de múltiples capas
                </p>
                <p className="text-amber-600 font-bold" data-id="element-345">
                  Valor: {fmt(bonusValue)}
                </p>
              </div>
              <div className="bg-amber-50 p-4 rounded-lg" data-id="element-346">
                <div className="mb-3 relative" data-id="element-347">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tXe9ukcZ91AJ6Z6wJDHSJG/c1.png" alt="Libro de Cheesecake de Maracuyá de Stella" className="w-full h-auto rounded-md shadow-sm" loading="lazy" width="400" height="300" decoding="async" data-id="element-348" />
                  <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-349">
                    GRATIS
                  </div>
                </div>
                <h4 className="font-bold text-amber-900 mb-2" data-id="element-350">
                  Cheesecake de Maracuyá
                </h4>
                <p className="text-sm text-gray-700 mb-2" data-id="element-351">
                  Sabor tropical irresistible
                </p>
                <p className="text-amber-600 font-bold" data-id="element-352">
                  Valor: {fmt(bonusValue)}
                </p>
              </div>
            </div>
            <p className="text-center text-amber-800 font-medium mb-6 order-3 md:order-2" data-id="element-353">
              ¡Solo por hoy, obtén estas 3 recetas premium completamente GRATIS!
            </p>
            <p className="text-center text-sm text-gray-700 mb-8 order-4 md:order-3" data-id="element-354">
              Un valor adicional de {fmt(totalBonusValue)} incluido sin costo
              extra
            </p>
            <div className="bg-amber-100 p-6 rounded-lg mb-8 order-1 md:order-4" data-id="element-355">
              <div className="text-center mb-4" data-id="element-356">
                <span className="inline-block bg-amber-600 text-white font-bold px-3 py-1 rounded-full text-sm mb-2" data-id="element-357">
                  MÁS COMÚN
                </span>
              </div>
              <div className="mb-6 relative" data-id="element-358">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2RTNkXmNh3tX5Jpr67nfKE/m3.png" alt="Colección de libros de recetas: Pavlova, Milhojas, Tarta Ópera y Cheesecake de Maracuyá" className="w-full h-auto rounded-lg shadow-sm mb-4" loading="lazy" width="800" height="500" decoding="async" data-id="element-359" />
              </div>
              <div className="flex justify-between items-center mb-4" data-id="element-360">
                <div data-id="element-361">
                  <p className="text-gray-700" data-id="element-362">Método Milhojas:</p>
                  <p className="text-gray-700" data-id="element-363">3 Recetas Bonus:</p>
                  <p className="font-bold text-amber-900" data-id="element-364">Valor Total:</p>
                </div>
                <div className="text-right" data-id="element-365">
                  <p className="text-gray-700" data-id="element-366">{fmt(basePrice)}</p>
                  <p className="text-gray-700" data-id="element-367">{fmt(totalBonusValue)}</p>
                  <p className="font-bold text-amber-900" data-id="element-368">{fmt(totalValue)}</p>
                </div>
              </div>
              <div className="text-center mb-6" data-id="element-369">
                <h3 className="text-xl font-bold text-amber-900 mb-2" data-id="element-370">
                  ¡OFERTA ESPECIAL HOY!
                </h3>
                <p className="text-3xl font-bold text-amber-600 mb-2" data-id="element-371">
                  {fmt(basePrice)}
                </p>
                <p className="text-gray-700 mb-1" data-id="element-372">
                  Método completo + 3 recetas bonus
                </p>
                <p className="text-sm text-amber-800" data-id="element-373">
                  ¡Ahorras {fmt(totalBonusValue)} comprando hoy!
                </p>
              </div>
              <ul className="space-y-2 mb-6" data-id="element-374">
                <li className="flex items-center gap-2" data-id="element-375">
                  <CheckIcon size={16} className="text-amber-600" data-id="element-376" />
                  <span className="text-gray-700" data-id="element-377">Recetas paso a paso</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-378">
                  <CheckIcon size={16} className="text-amber-600" data-id="element-379" />
                  <span className="text-gray-700" data-id="element-380">Secretos profesionales</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-381">
                  <CheckIcon size={16} className="text-amber-600" data-id="element-382" />
                  <span className="text-gray-700" data-id="element-383">
                    Técnicas de conservación
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-384">
                  <CheckIcon size={16} className="text-amber-600" data-id="element-385" />
                  <span className="text-gray-700" data-id="element-386">Acceso inmediato</span>
                </li>
              </ul>
              <a href={buildHotmartUrl('https://pay.hotmart.com/M104730533B?checkoutMode=10')} onClick={() => handleAddToCart(basePrice, 'Método Milhojas Perfecta', 'M101869446L')} className="block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-full text-lg text-center transition-colors animate-heartbeat" data-id="element-387">
                Comprar Ahora
              </a>
            </div>
            {/* Redesigned resell value section - more compact */}
            <div className="bg-amber-50 p-5 rounded-lg order-5 md:order-5" data-id="element-388">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-389">
                <div className="bg-white p-3 rounded-lg shadow-sm flex flex-col items-center justify-center text-center" data-id="element-390">
                  <CoinsIcon size={20} className="text-amber-600 mb-1" data-id="element-391" />
                  <p className="text-xl font-bold text-amber-900" data-id="element-392">
                    {fmt(milhojasPrice)}
                  </p>
                  <p className="text-xs text-gray-700" data-id="element-393">Valor por milhojas</p>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm flex flex-col items-center justify-center text-center" data-id="element-394">
                  <BarChartIcon size={20} className="text-amber-600 mb-1" data-id="element-395" />
                  <p className="text-xl font-bold text-amber-900" data-id="element-396">10x</p>
                  <p className="text-xs text-gray-700" data-id="element-397">Retorno de inversión</p>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm flex flex-col items-center justify-center text-center" data-id="element-398">
                  <PackageIcon size={20} className="text-amber-600 mb-1" data-id="element-399" />
                  <p className="text-xl font-bold text-amber-900" data-id="element-400">15+</p>
                  <p className="text-xs text-gray-700" data-id="element-401">Milhojas por mes</p>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm flex flex-col items-center justify-center text-center" data-id="element-402">
                  <CoinsIcon size={20} className="text-amber-600 mb-1" data-id="element-403" />
                  <p className="text-xl font-bold text-amber-900" data-id="element-404">
                    ${potentialMonthly.toLocaleString()}
                  </p>
                  <p className="text-xs text-gray-700" data-id="element-405">Ingresos mensuales</p>
                </div>
              </div>
              <p className="text-center text-sm text-amber-800 font-medium mt-4 mb-1" data-id="element-406">
                Convierte Tu Pasión en Negocio Rentable
              </p>
              <p className="text-center text-xs text-gray-700" data-id="element-407">
                Con solo una milhojas vendida recuperas tu inversión. Imagina
                las posibilidades vendiendo 15 por mes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}